<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderRight :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :headerTextEmpahasis="headerTextEmpahasis" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <div class="container">
        <Activation />
        <div class="text-center mt-5 mb-5 ">
            <p class="main-text ">What we do</p>
        </div>
        <b-row class="text-center">
            <b-col md="4" cols="12" class="mb-4">
                <img class="" src="../assets/images/connect.svg" alt="" />
                <p class="mt-4">We Connect</p>
            </b-col>
            <b-col md="4" cols="12" class="mb-4">
                <img class="" src="../assets/images/educate.svg" alt="" />
                <p class="mt-4">We Educate</p>
            </b-col>
            <b-col md="4" cols="12" class="mb-4">
                <img class="" src="../assets/images/build.svg" alt="" />
                <p class="mt-4">We build</p>
            </b-col>
        </b-row>
    </div>
    <section class="culture-section desktop">
    </section>
    <section class="culture-sec mobile">
        <img src="../assets/images/cultural-image.png" alt="">
        <div class="cul-black-section">
            <p>
                WE CREATE AN IMMERSIVE CULTURAL EXPERIENCE
            </p>
            <p>
                Culture Square is a platform that wants to be part of the human story; a story worth sharing with our communities, neighbors, and traveling guests. To achieve that, we know we need to be unconventional with a laser focus on event-oriented services to provide a glimpse of any culture around the world to anyone willing to experience its noble traditions, norms, and way of life. Culture Square ensures that it is an inclusive, diverse, and hospitable platform that connects, teaches, and is committed to building bridges where there are none. </p>
        </div>
    </section>
    <section class="text-center bg-culture-grey pb-8">
        <p class="main-text pt-8">
            WE CREATE AN IMMERSIVE CULTURAL EXPERIENCE
        </p>
        <p class="sub-text">
            Culture Square is a platform that wants to be part of the human story; a story worth sharing with our communities, neighbors, and traveling guests. To achieve that, we know we need to be unconventional with a laser focus on event-oriented services to provide a glimpse of any culture around the world to anyone willing to experience its noble traditions, norms, and way of life. Culture Square ensures that it is an inclusive, diverse, and hospitable platform that connects, teaches, and is committed to building bridges where there are none.
        </p>
    </section>
    <section class="text-center mt-5 mb-5">
        <p class="main-text">Experience unique Events</p>
        <p class="sub-main-text">
            We at Culture Square, make sure that a human moment is captured in all its authenticity whether it is with our online or face to face experiences.
        </p>
        <div class="mt-5 mb-5">
            <router-link to="/listings/events" class="btn btn-warning text-white">Join Us
                <font-awesome-icon :icon="['fas', 'arrow-right']" />
            </router-link>
        </div>

    </section>
    <Footer />

</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderRight from "@/components/BlackHeaderRight.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";

export default {
    name: "about-us",
    data: function () {
        return {
            headerText: "who we",
            headerTextEmpahasis: "are!",
            subText: "Get to know what culture square stands for.",
            fadedText: "About us"
        }
    },
    components: {
        Header,
        BlackHeaderRight,
        BlackHeaderMobile,
        BodyLinks,
        Activation,
        Footer,

    }
}
</script>

<style scoped>
.mb-5 {
    margin-bottom: 5rem !important
}
.pb-8{
    padding-bottom: 5rem !important
}
.pt-8{
    padding-top: 5rem !important
}
.main-text{
    margin-top:0 !important
}
.sub-text {
    margin: 0px 20%;
    color: #565C63;
}

.culture-section {
    height: 660px;
    margin-top: 100px;
    background-image: url('../assets/images/cultural-image.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.culture-sec img {
    height: 43vh
}

.culture-sec.mobile>img {
    width: 100%;
    height: 20rem;
}

.offset-black {
    height: 528px;
    width: 47%;
    background: #000;
    color: #fff;
    margin-top: -80px;
    position: absolute;
    padding: 3rem
}

.cul-black-section {
    background: #000;
    width: 100%;
    padding: 1.5rem;
    color: #fff;
}

.cul-black-section p:first-child {
    color: #F7B131;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: -0.25px;
}

.offset-black p {
    font-size: 18px;
    line-height: 32px;
    text-justify: auto;
    letter-spacing: 0.25px;

}

.offset-black p:first-child {
    font-weight: 600;
    font-size: 26px;
    letter-spacing: -0.25px;
    text-transform: uppercase;
    color: #F7B131;
}

.btn-warning {
    padding: 10px 30px;
}

@media screen and (min-width: 1400px) {
    .culture-section {
        background-repeat: no-repeat;
        background-size: cover;
    }
}
</style>
